import { Formik, Form } from 'formik';
import SettlementForm from './SettlementForm.js';
import { validateAutoAccidentSettlement } from "../utils/helper";
import { useProductContext } from '../contexts/ProductContext';
import { useConfirm } from '../contexts/ConfirmContext';
import XButton from './common/XButton';

const containerClasses =
    "bg-primary " +
    "rounded-b-lg overflow-hidden shadow-[0_2px_8px_rgba(0,0,0,0.1)] px-0.75 py-0 mb-6";

const cardClasses =
    "bg-white border border-border rounded-lg p-3.75 mb-1.5 last:mb-5";

const nameClasses = "text-xl font-semibold text-content mb-5";

const footerClasses = "py-2.5 px-0.5 flex justify-end gap-3";

const SettleAllView = ({
    plainTiffs,
    caseData,
    initialValues,
    onCancel,
    onSave,
    user,
    submitRef
}) => {
    const { isPFASType } = useProductContext();
    const confirm = useConfirm();

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values) => {
                    const isAutoAccidentOrPFAS =
                        caseData?.caseInfo?.caseType === 'AUTO_ACCIDENT' || (isPFASType && isPFASType(caseData?.caseInfo?.caseType));

                    for (const client of plainTiffs) {
                        const clientId = client.clientId;

                        const result = validateAutoAccidentSettlement({
                            isAutoAccident:isAutoAccidentOrPFAS,
                            thirdPartyAmount:
                                values?.[clientId]?.thirdPartySettlementAmount,
                            uimUmAmount:
                                values?.[clientId]?.uimUmSettlementAmount,
                            isCaseSettled:
                                values?.[clientId]?.isCaseSettled
                        });

                        if (!result.isValid) {
                            await confirm({
                                title: "Warning",
                                description: result.message,
                                confirmText: "OK",
                                cancelText: "Cancel",
                            });
                            return;
                        }

                        if (result.message) {
                            const ok = await confirm({
                                title: "Warning",
                                description: result.message,
                                confirmText: "Continue",
                                cancelText: "Cancel",
                            });
                            if (!ok) return;
                            onSave(values);
                            return;
                        }
                    }
                    onSave(values);
                }}
            >
                {({ submitForm, ...formik }) => {
                    submitRef.current = submitForm;
                    return (<Form>
                        <div className={containerClasses}>
                            {plainTiffs.map((client, index) => {
                                const isAlreadySettled = Boolean(client?.settlement?.settledAt);

                                return (
                                    <div key={index} className={cardClasses}>
                                        <h4 className={nameClasses}>
                                            {client.personalInfo?.clientName || 'N/A'}
                                        </h4>

                                        <SettlementForm
                                            clientId={client.clientId}
                                            client={client}
                                            caseData={caseData}
                                            isSettleAllView={true}
                                            isAlreadySettled={isAlreadySettled}
                                            user={user}
                                            formik={formik}
                                        />
                                    </div>
                                );
                            })}

                            <div className={footerClasses}>
                                <XButton
                                    variant="outlinePrimary"
                                    onClick={onCancel}
                                    className="bg-white! text-primary! border-white! hover:bg-primary! hover:text-white!"
                                >
                                    Cancel
                                </XButton>
                                <XButton type="submit">
                                    Done
                                </XButton>
                            </div>
                        </div>
                    </Form>)
                }}
            </Formik>
        </>
    );
};

export default SettleAllView;